import { render } from "./Image.vue?vue&type=template&id=85c5e7fc&scoped=true"
import script from "./Image.vue?vue&type=script&lang=ts"
export * from "./Image.vue?vue&type=script&lang=ts"

import "./Image.vue?vue&type=style&index=0&id=85c5e7fc&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-85c5e7fc"

export default script